(() => {
  const returnContainer = '#ph-returns__container';

  const returnsSelectOption = (selectOptions, object) => {
    let selectOptionsOpt = selectOptions;

    $.each(object, (key, value) => {
      selectOptionsOpt = `${selectOptionsOpt}<option value="${value.returnDesc}">${value.returnDesc}</option>`;
    });

    return selectOptionsOpt;
  };

  const returnsSelectOptionval = (result) => {
    let selectOptions = '';

    for (let key = 1; key < result.length; key = key + 1) {
      selectOptions = returnsSelectOption(selectOptions, result[key]);
    }

    return selectOptions;
  };

  const serviceNotificationMessage = (serviceResponseData) => {
    const returnSuccessMessageText = $('.ph-returnproduct__onsubmit--msg').html(),
        returnOnSuccessMessageText = $('.ph-returnproduct__onsubmit--successmsg').html(),
        returnOnFailureMessageText = $('.ph-returnproduct__onsubmit--failuremsg').html(),
        salesAreaTypes = [
          'src',
          'matc',
          'sps'
        ];

    let subOrderSuccessMessage = '',
        subOrderFailedMessage = '',
        anyErrorMessage = false;

    $.each(serviceResponseData, (indexValue, currentItem) => {
      const {subOrderId} = currentItem,
          serviceNotificationData = currentItem.serviceNotificationResponseData;
      let conditionalSuccessMessageText = returnOnSuccessMessageText;

      if (currentItem.salesAreaType && salesAreaTypes.indexOf(currentItem.salesAreaType) >= 0) {
        conditionalSuccessMessageText = $(`.ph-returnproduct__onsubmit--successmsg${currentItem.salesAreaType}`).html();
      }

      if (serviceNotificationData.serviceNotificationNumber && String(serviceNotificationData.responseStatus) !== 'ERROR') {
        const successMessageWithSubOrder = conditionalSuccessMessageText.replace('{0}', subOrderId);
        const successMessageWithServiceNumber = successMessageWithSubOrder.replace('{1}', serviceNotificationData.serviceNotificationNumber);

        subOrderSuccessMessage = `${subOrderSuccessMessage}<p class="ph-return_success ph-col-11 ph-pt-0">${successMessageWithServiceNumber}</p>`;
      } else if (serviceNotificationData.responseStatus && String(serviceNotificationData.responseStatus) === 'ERROR') {
        const failedMessageWithSubOrder = returnOnFailureMessageText.replace('{0}', subOrderId);

        subOrderFailedMessage = `${subOrderFailedMessage}<p class="ph-return_failure ph-col-11 ph-mt-1 ph-pb-0 ph-pt-0">
        ${failedMessageWithSubOrder}</p>`;
        anyErrorMessage = true;
      }
    });

    let successMessage = `<div class="ph-regularreturn__response ph-info_positive ph-information_message ph-col-12">
    <span class="single"></span>      
    <p class="ph-icon-close ph-info-closebtn ph-d-inline-block ph-icon-close ph-info-closebtn ph-d-inline-block ph-float-right ph-error-closebtn">
    </p><p class="ph-col-11 ph-return__generic ph-flag_off">${returnSuccessMessageText}</p>${subOrderSuccessMessage}</div>`;

    if (anyErrorMessage) {
      successMessage = `${successMessage}<div class="ph-regularreturn__response ph-info_negative ph-information_message ph-col-12 ph-pb-1">
      <span class="single"></span>      
      <p class="ph-icon-close ph-info-closebtn ph-d-inline-block ph-icon-close 
      ph-info-closebtn ph-d-inline-block ph-float-right ph-error-closebtn"></p>${subOrderFailedMessage}</div>`;
    }

    $('#globalMessages').append(successMessage);
  };

  const clickSubmitHhs = (currentStoreId, hhsUsStoreId, hhsCaStoreId, returnData) => {
    if (currentStoreId === hhsUsStoreId ||
        currentStoreId === hhsCaStoreId) {
      returnData.serialNumbers = $('#serialNumbers').val();
      $('.ph-returns__submit').addClass('ph-disabledbutton');
    }
  };

  const returnordermodal = (result, orderId) => {
    const selectOptions = returnsSelectOptionval(result),
        returnProductsText = $('.ph-returnproduct__heading').html(),
        returnReasonText = $('.ph-returnproduct__dropdown--heading').html(),
        returnSubmitText = $('.ph-returnproduct__submit').html(),
        returnCancelText = $('.ph-returnproduct__cancel').html(),
        returnAlreadyReturnedText = $('.ph-returnproduct__alreadyreturned').html(),
        returnQuantityText = $('.ph-returnproduct__quantity').html(),
        hhsUsStoreId = 'hhs-philips-us',
        hhsCaStoreId = 'hhs-philips-ca',
        returnSerialNumberText = $('.serialnumber_infotext').html(),
        currentStoreId = document.querySelector('#currentStoreId').value;


    let productDetail = '',
        selectOptionQty = '',
        serialNumberInputBox = '',
        returnDetails = '';

    for (returnDetails in result[0]) {
      if ({}.hasOwnProperty.call(result[0], returnDetails)) {
        selectOptionQty = '';

        let code = '',
            sapOrderCode = '';

        for (let key = 1; key <= result[0][returnDetails].quantity; key = key + 1) {
          selectOptionQty = `${selectOptionQty}<option>${key}/${result[0][returnDetails].quantity}</option>`;
        }

        if (result[0][returnDetails].product.ctn === result[0][returnDetails].product.code) {
          code = `<p class="ph-m-0 ph-orderhistory_fontstyle ph-returns__prodctn">${result[0][returnDetails].product.ctn}</p>`;
        } else {
          code = `<p class="ph-m-0 ph-orderhistory_fontstyle ph-returns__prodctn">
        ${result[0][returnDetails].product.ctn} / ${result[0][returnDetails].product.code}</p>`;
        }

        /* eslint-disable prefer-destructuring */
        if (result[0][returnDetails].sapOrderCode) {
          sapOrderCode = result[0][returnDetails].sapOrderCode;
        }
        /* eslint-enable prefer-destructuring */

        productDetail = `${productDetail} <li class="ph-returns__productlist ph-float-left ph-col-12" 
        data-deliverystatus=${result[0][returnDetails].deliveryStatus}>
        <div class="ph-returns__prodimg ph-col-2 ph-p-0 ph-float-left"><a href=${result[0][returnDetails].product.url}> <div class="ph-p-0">
        <img src=${result[0][returnDetails].product.imageURL} 
        alt=${result[0][returnDetails].product.name} title=${result[0][returnDetails].product.name}>
        </div>
        </a></div>
        <div class="ph-retuns__proddetails ph-col-10 ph-float-left"
         data-entrynumber=${result[0][returnDetails].entryNumber} data-sapordercode=${sapOrderCode}>
        <div class="ph-col-12 ph-p-0">
        <a href=${result[0][returnDetails].product.url}>
        <p class="ph-orderhistory_fontstyle ph-m-0 strong">${result[0][returnDetails].product.name}</p>
        ${code}
        </a>
        </div>
        <div class="ph-col-12 ph-p-0">
        <div class="form-field-input ph-icon-arrow-down ph-col-8 ph-p-0 ph-float-left ph-mr-1">
        <select name="returnoption" class="ph-forminput ph-formselect ph-return__reason">${selectOptions}</select>
        <label class="ph-formlabel ph-p-0" for="userTitle">${returnReasonText}</label>
        </div>
        <div class="form-field-input ph-icon-arrow-down ph-quantity__wrapper ph-col-3 ph-p-0 ph-float-left">
        <select name="returnquantity" class="ph-forminput ph-formselect ph-return__quantity">${selectOptionQty}</select>
        <label class="ph-formlabel ph-p-0" for="userTitle">${returnQuantityText}</label>
        </div>
        </div>
        </div>
        </li>`;
      }
    }

    if (currentStoreId === hhsUsStoreId || currentStoreId === hhsCaStoreId) {
      serialNumberInputBox = `<li class="ph-returns__serialnumber ph-float-right ph-col-12">
    <div class="ph-serialn_input form-field-input ph-col-10 ph-float-right">
    <input id="serialNumbers" name="serialNumber" class="text ph-forminput ph-m-0" 
    placeholder="placeholder" type="text"  maxlength="4000" autocomplete="off"></input>
    <label class="ph-formlabel ph-p-0" for="userTitle">Serial Number(s)</label>
    </div>
    <div class="ph-col-10 ph-returns_infotext ph-float-right">
    <span>${returnSerialNumberText}</span>
    </div>
    </li>`;
    }

    productDetail = `<div class="ph-returns__header ph-float-left ph-col-12">
    <div class="ph-col-12 ph-float-left ph-orderhistory_fontstyle">
    <h4 class="ph-m-0">${returnProductsText + orderId}</h4>
    </div>
    </div>
    <div class="ph-returns__header ph-returns__status ph-float-left ph-col-12">
    <div class="ph-col-12 ph-my-1 ph-float-left">
    <h3>${returnAlreadyReturnedText}</h3>
    </div>
    </div>
    <div class="ph-returns__content ph-col-12 ph-float-left ph-p-0"><ul class="ph-m-0 ph-returns__contentlist">
    ${productDetail}
    ${serialNumberInputBox}
    </ul></div>
    <form method="post" id="myretrunForm" class="ph-col-12 ph-float-left ph-return__buttons ph-text-center">
    <a  class="ph-returns__submit" href="javascript:void(0)">${returnSubmitText}</a>
    <a  class="ph-returns__cancel" href="javascript:void(0)">${returnCancelText}</a>
    </form>`;

    $(`${returnContainer}`).html(productDetail);

    $('.ph-returns__submit').unbind('click');

    $('.ph-returns__submit').on('click', () => {
      const returnData = {};

      $('.ph-returns__productlist').each(function(key) {
        /* eslint-disable prefer-destructuring */
        const entryNumber = $(this).find('.ph-retuns__proddetails').attr('data-entrynumber'),
            sapOrderCode = $(this).find('.ph-retuns__proddetails').attr('data-sapordercode'),
            prodqty = $(this).find('.ph-return__quantity').find(':selected').text().split('/')[0],
            returnReason = $(this).find('.ph-return__reason option:selected').text(),
            returnValue = returnReason !== 'Do not return this product';

        /* eslint-enable prefer-destructuring */

        returnData[`returnEntry[${key}].returnCheck`] = returnValue;
        returnData[`_returnEntry[${key}].returnCheck`] = 'on';
        returnData[`returnEntry[${key}].returnEntry`] = entryNumber;
        returnData[`returnEntry[${key}].returnQuantity`] = prodqty;
        returnData[`returnEntry[${key}].returnReason`] = returnReason;
        returnData[`returnEntry[${key}].sapOrderCode`] = sapOrderCode;
      });

      clickSubmitHhs(currentStoreId, hhsUsStoreId, hhsCaStoreId, returnData);

      $.ajax({
        url: `${ACC.config.contextPath}returns/setOrderReturns.json?returnOrderCode=${orderId}`,
        type: 'POST',
        dataType: 'json',
        data: returnData,
        success: (serviceResponseData) => {
          $('html, body').animate({
            scrollTop: 0
          }, 'slow');

          serviceNotificationMessage(serviceResponseData);

          $.colorbox.close();
        },
        error: () => {
          $.colorbox.close();
        }
      });
    });
  };

  const returnorderclick = () => {
    $(document).on('click', '.ph-orderhistory_return', function() {
      const orderId = $(this).attr('data-orderid');

      $('#globalMessages').empty();
      $.getJSON(`${ACC.config.contextPath}returns/return.json?returnOrderCode=${orderId}`, (result) => {
        returnordermodal(result, orderId);

        const statusArray = [];

        let closeStructure = '';

        closeStructure = `${closeStructure} <button type='button' id='ph-cboxClose'><span class='ph-icon-cross'></span></button>`;

        $('.ph-returns__productlist').each(() => {
          statusArray.push($(this).attr('data-deliverystatus'));

          if ($(this).attr('data-deliverystatus') === 'FULL_RETURN_SUBMITTED' || $(this).attr('data-deliverystatus') === 'RETURNED') {
            $(this).hide();
          }
        });

        if (statusArray.includes('PARTIAL_RETURN_SUBMITTED') || statusArray.includes('FULL_RETURN_SUBMITTED') || statusArray.includes('RETURNED')) {
          $('.ph-returns__status').show();
        } else {
          $('.ph-returns__status').hide();
        }

        $('.ph-quantity__wrapper').hide();
        $(document).on('change', '.ph-return__reason', function() {
          if ($(this).val() === 'Do not return this product') {
            $(this).parent().next().hide();
          } else {
            $(this).parent().next().show();
          }
        });
        $('.ph-returns__cancel').on('click', () => {
          $.colorbox.close();
          $(`${returnContainer}`).empty();
        });
        $.colorbox({
          inline: true,
          href: '#ph-returns__container',
          maxWidth: '522px',
          width: '100%',
          height: '100%',
          scrolling: true,
          overlayClose: false,
          escKey: true,
          close: closeStructure,
          onClosed: () => {
            ACC.common.refreshScreenReaderBuffer();
            $(`${returnContainer}`).empty();
          }
        });
      });
    });
  };

  $(document).ready(() => {
    returnorderclick();
  });
})();
